import { app } from '../../app.module'
app
  // カテゴリテーブルのアクション
  .directive('categoryTableActions', () => {
    return {
      restrict: 'EA',
      template: require('./category-table-actions.pug')(),
      controller: ($scope, CategoryService) => {
        $scope.deleteCategory = function (category) {
          // 確認メッセージ
          if (confirm('サブカテゴリが削除されます。本当に削除してよろしいですか?')) {
            const deleteCategory = {
              categoryName: category.categoryName,
              subCategoryName: category.subCategoryName,
            }

            // カテゴリを削除
            CategoryService.CategoryData.deleteSubCategory(deleteCategory).then((result) => {
              // 削除成功の場合
              if (result !== null && result !== undefined) {
                // カテゴリ一覧に削除されたカテゴリを表示しない
                category.hide = true
                // カテゴリ情報が変更されたことを親スコープへ通知
                $scope.$emit('changeCategoriesList')
              }
            })
          }
        }
      },
    }
  })
